//
//
//
//
//
//
//
//
//
//
//

import PartnerHeader from '../components/partners/TheHeader.vue'
import MobileHeader from '../components/partners/MobileHeader.vue'
import SupportWidget from '../../components/support/SupportWidget.vue'

export default {
    name: 'PartnersSetup',
    components: {
        PartnerHeader,
        MobileHeader,
        SupportWidget
    }
}
